import {
  Input,
  InputOnChangeData,
  InputProps,
} from "@fluentui/react-components";

import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";
import { FluentProvider } from "..";

interface InputCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
  onChangeText?: (
    event: React.ChangeEvent<HTMLInputElement>,
    newValue?: string,
  ) => void;
}

const InputCustom = (props: InputCustomProps & InputProps) => {
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles,
  );

  const onChange = (
    ev: React.ChangeEvent<HTMLInputElement>,
    data: InputOnChangeData,
  ) => {
    if (props.onChangeText) {
      props.onChangeText(ev, data.value);
    }
  };
  return props.theme ? (
    <FluentProvider theme={props.theme}>
      <Input
        {...props}
        onChange={onChange}
        disabled={props.disabled || !isCanBeVisible}
      />
    </FluentProvider>
  ) : (
    <Input
      {...props}
      onChange={onChange}
      disabled={props.disabled || !isCanBeVisible}
    />
  );
};

export default InputCustom;
